<template>
  <div>
    <v-alert
      v-if="!isUserLoggedIn"
      color="primary"
      dense
      type="info"
      class="mb-6"
    >
      You have not clocked in yet, correct?
    </v-alert>

    <tasksList :tasks="store.getMyTasks" />
    <ReocurringTaskDashBoard :reocurring-tasks="reoccuringTasksStore.getOwnReocurringTasks" />

    <v-card class="mt-4">
      <Calendar
        :events="roster"
        :initial-view="defaultView"
        :new-view="newRosterView"
        @view-change="updateLatestOpenedView"
      />
    </v-card>
  </div>
</template>


<script setup>
import { usePlannedWorkStore } from "@/stores/plannedWorkStore";
import { useReoccurringTasksStore } from "@/stores/reoccuringTaskStore";
import TasksList from "@/components/tasks/tasksList.vue";
import Calendar from "@/components/calendar.vue";
import {useRosterStore} from "@/stores/rosterStore";
import {onMounted} from "vue";
import jwtInterceptor from "@/plugins/jwtInterceptor";
import {useDisplay} from "vuetify";
import ReocurringTaskDashBoard from "@/components/ReocurringTasks/ReocurringTaskDashBoard.vue";
import {
  addDays,
  addMinutes,
  differenceInCalendarDays,
  formatISO,
  getDate,
  parseISO,
  setHours,
  setMinutes
} from "date-fns";
import {Preferences} from "@capacitor/preferences";
import {useUserStore} from "@/stores/user";
import { useHead } from "unhead";

const store = usePlannedWorkStore();
const rosterStore = useRosterStore();
const reoccuringTasksStore = useReoccurringTasksStore();
const userStore = useUserStore()
const newRosterView = ref('dayGridMonth')
const isUserLoggedIn = ref(false);
const { xs } = useDisplay()
const currentView = ref();
const defaultView = ref('yearList');
let intervalId

useHead({
  title: 'Dashboard - Platcop'
});
const getDefaultView = () => {
  if (xs.value) {
    return 'yearList'
  }
  return 'dayGridMonth'
}

const getRosterFormated = () => {
  const newRoster = [...rosterStore.getMyRoster ]

  for (let i = 0; i < rosterStore.getMyRoster.length; i++) {
    const currentDay = rosterStore.getMyRoster[i];
    const nextDay = rosterStore.getMyRoster[i + 1];

    if (currentDay.StartTime && currentDay.EndTime) {
      const currentStart = parseISO(currentDay.StartTime);
      const currentEnd = parseISO(currentDay.EndTime);

      if (Math.abs(getDate(currentEnd) - getDate(currentStart)) > 0) {
        const newEndTime = formatISO(addMinutes(currentStart,1));
        newRoster[i].overrideExitDate = currentEnd;
        newRoster[i].EndTime = newEndTime;
      }
    }

    if(nextDay) {
      const currentDate = parseISO(currentDay.EndTime)
      const nextDate = parseISO(nextDay.StartTime)

      const daysDiff = differenceInCalendarDays(nextDate,currentDate);

      if (daysDiff > 1) {
        for (let d = 1; d< daysDiff; d++) {
          const newDate = setMinutes(setHours(addDays(currentDate, d),0),0);
          const newEndDate = setMinutes(setHours(addDays(currentDate, d),0),0);
          const clonedDay = {...currentDay};
          clonedDay.id = i + d;
          clonedDay.StartTime = formatISO(newDate);
          clonedDay.EndTime = formatISO(newEndDate);
          clonedDay.EntryType = 'time-off';
          clonedDay.shiftGroupDetails.location = rosterStore.getMyRoster[i].shiftGroupDetails?.location;
          newRoster.push(clonedDay);
        }
      }
    }
  }
  return newRoster;
}

const roster = computed(() => {
  defaultView.value = getDefaultView();
  if(currentView.value === "yearList") {
    return getRosterFormated();
  }
  return rosterStore.getMyRoster;
});

onMounted(() => {
  store.renewYourTasks();
  rosterStore.loadMyRoster();
  reoccuringTasksStore.loadOwnReocurringTasks(true)
  getClockDetails()
  intervalId = setInterval(() => {
    store.renewYourTasks(true);
    reoccuringTasksStore.loadOwnReocurringTasks(true)
  }, 60 * 1000);
})



onUnmounted(() => {
  // Clear the interval when the component is unmounted
  if (intervalId) {
    clearInterval(intervalId);
  }
});

const updateLatestOpenedView =(view) =>{
  currentView.value = view;
  console.log("CURRENT VIEW TRIGGER")
  if(xs.value) {
    return
  }
  console.debug("Roster view to be update in storage to: "+view)
  Preferences.set({
    key: 'lastOpenedRosterView',
    value: view,
  })
}

const getClockDetails = function() {
  if (!userStore.getUserInfo) {
    console.warn("DASHBOARD: Skipping clock check - User info is missing.");
    isUserLoggedIn.value = false;
    return;
  }
  jwtInterceptor.get('v1/clock/is-clocked/'+userStore.getUserInfo.usersign).then(response => {
    console.debug("DASHBOARD: clock status for user: "+userStore.getUserInfo.usersign+" from api is: "+response.data)
    if(response.data === null) {
      isUserLoggedIn.value = false
      return
    }
    isUserLoggedIn.value = true
    })
}

</script>
